// extracted by mini-css-extract-plugin
export var actionButton = "_l2-0";
export var fileInput = "_l2-2";
export var paperclip = "_l2-1";